import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LeadTagColor } from "../../../../agent/src/core/leadTag/types";

export const TAG_COLOR_CLASSES: Record<LeadTagColor, string> = {
  purple: "bg-purple-100 text-purple-800",
  blue: "bg-blue-100 text-blue-800",
  teal: "bg-teal-100 text-teal-800",
  green: "bg-green-100 text-green-800",
  amber: "bg-amber-100 text-amber-800",
  red: "bg-red-100 text-red-800",
  pink: "bg-pink-100 text-pink-800",
  gray: "bg-gray-100 text-gray-800",
};

type TagChipProps = {
  name: string;
  color: LeadTagColor;
  archived?: boolean;
  onRemove?: () => void;
};

const TagChip = ({ name, color, archived, onRemove }: TagChipProps) => {
  const chipClassName = cn(
    "min-w-0 truncate rounded-pill border px-2 py-0.5 text-xs font-medium",
    archived
      ? "border-dashed border-neutral-300 text-neutral-500"
      : cn("border-transparent", TAG_COLOR_CLASSES[color])
  );

  if (!onRemove) return <span className={chipClassName}>{name}</span>;

  return (
    <button
      type="button"
      onClick={onRemove}
      aria-label={`Quitar etiqueta ${name}`}
      className="flex min-h-11 min-w-0 items-center rounded-pill focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <span className={cn(chipClassName, "flex items-center gap-1")}>
        <span className="truncate">{name}</span>
        <X className="size-3 shrink-0" aria-hidden />
      </span>
    </button>
  );
};

export default TagChip;
